import gql from 'graphql-tag';

export default gql`
  mutation CreateAnalyticsEvent(
    $url: String!,
    $title: String,
    $subjectType: String,
    $subjectId: String,
    $payload: Json
  ) {
    createAnalyticsEvent(
      type: PAGEVIEW,
      url: $url,
      title: $title,
      subjectType: $subjectType,
      subjectId: $subjectId,
      payload: $payload
    ) {
      id
    }
  }
`;
